





































import Vue from 'vue';
import { IIcons } from '@/common/interfaces/index.interface';
import TIcons from '@/types/TIcons';

interface IAddToCartButtonComponent {
  icons: IIcons;
}

export default Vue.extend({
  name: `AddToCartButton`,
  data(): IAddToCartButtonComponent {
    return {
      icons: TIcons,
    };
  },
  props: {
    addedToCart: {
      required: true,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    growOnHover: {
      default: false,
      type: Boolean,
    },
    label: {
      default: ``,
      type: String,
    },
    loading: {
      required: true,
      type: Boolean,
    },
    small: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    onClick(): void {
      this.$emit(`click`);
    },
  },
});
